import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=4a63e4a4&scoped=true&"
import script from "./EditDialog.vue?vue&type=script&lang=js&"
export * from "./EditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63e4a4",
  null
  
)

export default component.exports